import { PUBLISH_TABS } from 'ContentEditorUI/lib/publishing/constants';
export const NEW_PUBLISH_OPTIONS = Object.assign({}, PUBLISH_TABS, {
  CONTACT_STO: 'contact_sto'
});